import * as yup from "yup";
import { useState, useEffect } from "react";
import { useForm } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import { IoSaveOutline } from "react-icons/io5";
import { FaCircleNotch } from "react-icons/fa";
import { saveAccountContactInfoAsync } from "./../../../../../services/accountService";
import { EMAIL_ALREADY_EXISTS } from "./../../../../../utils/constants";
import Textbox from "./../../../../../components/common/Textbox";
import TextboxMask from "./../../../../../components/common/TextboxMask";
import Toaster from "./../../../../../components/common/Toaster";

const schema = yup.object({
  id: yup.string(),
  email: yup.string().required("Please enter a valid email address."),
  phone_number: yup.string().required("Please enter phone number."),
});

const ContactForm = ({ data, isLoading, setLoading, onSuccess }) => {
  const [emailExists, setEmailExists] = useState(false);

  const {
    register,
    handleSubmit,
    setValue,
    formState: { errors },
  } = useForm({ resolver: yupResolver(schema) });

  const onSubmit = async (data) => {
    try {
      setLoading(true);
      await saveAccountContactInfoAsync(data);
      Toaster.Success("Information Saved Successfully");
      onSuccess();
    } catch (ex) {
      if (ex.response && ex.response.data.message === EMAIL_ALREADY_EXISTS) {
        setEmailExists(true);
        return;
      }

      Toaster.Error("Something went wrong.");
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    const populateForm = () => {
      setValue("id", data.id);
      setValue("email", data.email);
      setValue("phone_number", data.phone_number);
    };

    if (data) populateForm();
  }, [data, setValue]);

  return (
    <form onSubmit={handleSubmit(onSubmit)} className="p-8 space-y-6">
      <div className="grid-cols-2">
        <Textbox
          id="email-textbox"
          name="email"
          title="Email Address"
          type="email"
          register={register("email")}
          errors={errors}
        />
        {emailExists && (
          <div className="pt-2">
            <span className="text-sm text-red-400">{EMAIL_ALREADY_EXISTS}</span>
          </div>
        )}
      </div>
      <div className="grid-cols-2">
        <TextboxMask
          id="phone-number-textbox"
          name="phone_number"
          type="tel"
          title="Phone Number"
          format="+63 ### ### ####"
          value={data.phone_number}
          setValue={setValue}
          register={register("phone_number")}
          errors={errors}
        />
      </div>
      <div className="grid grid-2 pt-2">
        <div className="col-span-2">
          <button
            type="submit"
            className="button button-primary disabled:opacity-70 disabled:cursor-not-allowed"
            disabled={isLoading}
          >
            {isLoading && <FaCircleNotch className="animate-spin mr-3" />}
            {!isLoading && <IoSaveOutline className="mr-3" />}
            Save Changes
          </button>
        </div>
      </div>
    </form>
  );
};

export default ContactForm;
